import * as reducers from "./data/reducers";
import * as actions from "./data/actions";

const state = {
  billboards: reducers.Billboards(undefined, {})
};

export default {
  actions,
  reducers,
  state
};



// WEBPACK FOOTER //
// ./src/store/billboards/index.js